import { PagesRoutes } from "./pages.config"; 

export const ROUTES_MAP = {
  INDICATOR: PagesRoutes.INDICATOR,
  CLIENTS: "/accounts-receivable/" + PagesRoutes.CLIENTS,
  PARENTS: "/accounts-receivable/" + PagesRoutes.PAYMENT_RESPONSIBLE,
  PAYMENT_ORDERS: "/accounts-receivable/" + PagesRoutes.PAYMENT_ORDERS,
  RECOVERY_PORTFOLIO: "/accounts-receivable/" + PagesRoutes.RECOVERY_PORTFOLIO,
  COMMUNICATIONS: "/accounts-receivable/" + PagesRoutes.COMMUNICATIONS,
  PROCESS_LOG: "/accounts-receivable/" + PagesRoutes.PROCESS_LOG,
  PAYMENT_ACTIONS: "/accounts-receivable/" + PagesRoutes.PAYMENT_ACTIONS,
  PAYMENT_RESPONSIBLE: "/accounts-receivable/" + PagesRoutes.PAYMENT_RESPONSIBLE,

  CREDIT_PAYMENT_ORDERS: "/credit/" + PagesRoutes.CREDITS_PAYMENT_ORDERS,
  CREDIT_CLIENTS: "/credit/" + PagesRoutes.CLIENTS,
  CREDITS_DETAILS: "/credit/" + PagesRoutes.CREDITS_DETAILS,

  CONTACTABILITY: "/strategies/" + PagesRoutes.CONTACTABILITY,
  POPULATION: "/strategies/" + PagesRoutes.POPULATION,
  TEMPLATE: "/strategies/" + PagesRoutes.TEMPLATE,
  TEMPLATE_EDIT: "/strategies/" + PagesRoutes.TEMPLATE + "/form-template",
  FLOW: "/strategies/" + PagesRoutes.FLOW,
  FLOW_EDIT: "/strategies/" + PagesRoutes.FLOW + "/form-flow/",
  EVENT: "/strategies/" + PagesRoutes.EVENT,

  CONVERSATIONS: "/" + PagesRoutes.CONVERSATIONS,
  CONTROL_CENTER: "/" + PagesRoutes.CONTROL_CENTER,
  CAMPAIGN: "/" + PagesRoutes.CAMPAIGN,
  CAMPAIGN_FORM: `/${PagesRoutes.CAMPAIGN}/form/`,
  WEB_FORM: "/" + PagesRoutes.WEB_FORM,
  WEB_FORM_EDIT: "/" + PagesRoutes.WEB_FORM + "/edit-form",
  MARKET_PLACE: "/" + PagesRoutes.MARKETPLACE,
  MARKET_PLACE_DETAILS: "/" + PagesRoutes.MARKETPLACE + "/details/",
  MY_PROFILE: "/my-account/my-profile",
  INVOICE: "/my-account/" + PagesRoutes.INVOICE,
  //MOONFLOW_TALK: "/my-account/" + PagesRoutes.MOONFLOW_TALK,
  MOONFLOW_AI_METRICS: "/my-account/" + PagesRoutes.MOONFLOW_AI_METRICS,
  GENERAL_INFORMATION: "/my-account/account-settings/" + PagesRoutes.GENERAL_INFORMATION,

  CHANNEL_MANAGEMENT: "/my-account/" + PagesRoutes.CHANNEL_MANAGEMENT,
  INTEGRATIONS: "/my-account/" + PagesRoutes.INTEGRATIONS + "/credentials",
  FIELD_MAPPING: "/my-account/" + PagesRoutes.INTEGRATIONS + "/file-transfer-sftp/field-mapping",
  SFTP_MAPPING: "/my-account/" + PagesRoutes.INTEGRATIONS + "/file-transfer-sftp/sftp",
  API: "/my-account/" + PagesRoutes.INTEGRATIONS + "/api",
  ADVANCED_CONFIGURATION: "/my-account/" + PagesRoutes.INTEGRATIONS + "/advanced-configuration",

  PAYMENT_METHODS: "/my-account/" + PagesRoutes.PAYMENT_METHODS,
  OTHER_CONFIGURATIONS: "/my-account/" + PagesRoutes.OTHER_CONFIGURATIONS,
  USERS: "/my-account/" + PagesRoutes.USERS,
  CREDIT_CONFIGURATION: "/credit-configuration",
  CREDIT_SCHEDULE: "/credit-configuration/" + PagesRoutes.CREDIT_SCHEDULE_CONFIGURATION,
  ONBOARDING: "/onboarding",
  WELCOME: "/welcome",

  PURCHASE_ORDER: "/" + PagesRoutes.PURCHASE_ORDER,
  PURCHASE_ORDER_LIST: "/" + PagesRoutes.PURCHASE_ORDER + "/list",

  TELEPHONY: "/" + PagesRoutes.TELEPHONY,


  COLLECTION_RECONCILIATION_SUMMARY: "/collections-reconciliation" + "/" + PagesRoutes.COLLECTION_RECONCILIATION_SUMMARY,
  COLLECTION_RECONCILIATION_DETAILS: "/collections-reconciliation" + "/" + PagesRoutes.COLLECTION_RECONCILIATION_DETAILS,
  COLLECTION_RECONCILIATION_CONFIGURATIONS: "/collections-reconciliation" + "/" + PagesRoutes.COLLECTION_RECONCILIATION_CONFIGURATION,

  FIELD_MANAGEMENT_MANAGERS: "/field-management" + "/" + PagesRoutes.FIELD_MANAGEMENT_MANAGERS,
  FIELD_MANAGEMENT_MAP: "/field-management" + "/" + PagesRoutes.FIELD_MANAGEMENT_MAP,
  FIELD_MANAGEMENT_VISITS: "/field-management" + "/" + PagesRoutes.FIELD_MANAGEMENT_VISITS,

  INITIAL: "/",
  LOGIN: "/auth/login",
  REGISTRATION: "/auth/registration",
  PENDING_VALIDATION: "/auth/pending-validation",
  REFRESH: "/auth/refresh",


};
